import { PageType } from "@tvg/product-listing-url/lib/Types/types";
import Accordion from "client/components/Accordion";
import Heading from "client/components/Heading";
import useGlobalConfig from "client/context/GlobalConfig";
import useSEOConfig from "client/context/SEOContext";
import { BrandNameMap } from "common/utils/seo/consts";
import { constructPageTitle, constructSimplePageTitle } from "common/utils/seo/seo-title";
import React, { useEffect, useMemo } from "react";

const DynamicHeading = () => {
  const { pageType, searchTerm, brand } = useGlobalConfig();
  const { overrides, fallback, unfilteredFacet } = useSEOConfig();

  useEffect(() => {
    if (pageType === PageType.search) {
      const formattedBrand = BrandNameMap[brand] ?? brand;
      document.title = searchTerm
        ? `Search results for "${searchTerm}" | ${formattedBrand}`
        : `Search results for ${formattedBrand}`;
    }
  }, [pageType, searchTerm, brand]);

  const accordionContent = useMemo(() => {
    if (!overrides?.h1?.trim() || !overrides.torso?.trim()) return "";
    return overrides.torso;
  }, [overrides?.h1, overrides?.torso]);

  const pageHeading = useMemo(() => {
    if (overrides?.h1?.trim()) return overrides.h1;
    if (pageType !== PageType.browse) {
      return constructSimplePageTitle({ type: pageType, term: searchTerm, response: fallback, brand });
    }
    if (!fallback) return "";

    const title = constructPageTitle(fallback, { unfilteredFacet, brand });
    return title.trim().split(" |").join(",").slice(0, -1);
  }, [overrides, fallback?.meta.result_id, pageType, searchTerm]);

  return !accordionContent ? (
    <Heading>{pageHeading}</Heading>
  ) : (
    <Accordion heading={pageHeading}>{accordionContent}</Accordion>
  );
};

export default React.memo(DynamicHeading);
